import React from 'react';
import { GridWrapper } from '@yme/atoms/grid';
import { IndentWrapper } from '../Separator';
import { EmbedContainer } from './styled';
export function Embed({ html, isCustomGrid, isRemoveBottomIndent }) {
    if (isCustomGrid) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(GridWrapper, null,
                React.createElement(EmbedContainer, { dangerouslySetInnerHTML: {
                        __html: html,
                    } }))));
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(EmbedContainer, { dangerouslySetInnerHTML: {
                __html: html,
            } })));
}
